module.exports = __webpack_public_path__ + "static/media/pamain-extrabold.d87d005e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-extrabold.woff
// module id = ./src/assets/fonts/pamain-extrabold.woff
// module chunks = 0